import Vue from 'vue'
import Vuex from 'vuex'
import { firebaseAuth, firebaseDatabase } from '@/services/firebase'

Vue.use(Vuex)

export default {
  namespaced: true,
  state: {
    channelSnippet: null,
    channelStatistics: null,
    channelBranding: null,
    viewStat: null,
    subscriberStat: null,
  },
  mutations: {
    setViewStat(state, payload) {
      state.viewStat = payload.rows[0][0]
      console.log('setViewStat')
    },
    setSubscriberStat(state, payload) {
      state.subscriberStat = payload.rows[0][1] - payload.rows[0][2]
      console.log('setSubscriberStat')
    },
    setChannelSnippet(state, payload) {
      state.channelSnippet = payload.items[0].snippet
    },
    setChannelBranding(state, payload) {
      state.channelBranding = payload.items[0].brandingSettings
    },
    setChannelStatistics(state, payload) {
      state.channelStatistics = payload.items[0].statistics
    },
  },
  actions: {
    getYoutubeData(context, response) {
      context.commit('setViewStat', response)
      context.commit('setSubscriberStat', response)
    },
    async getChannelSnippet(context, response) {
      // const channelSnippet = []
      // const apiSnippetUrl = `https://youtube.googleapis.com/youtube/v3/channels?part=snippet&id=${this.state.youtube.channelID}&key=AIzaSyA2a7e3NA1RyZbyCw2Zt9jSpBjnp1xzzRc`
      // const apiSnippetUrl = 'https://youtube.googleapis.com/youtube/v3/channels?part=snippet&mine=true&key=AIzaSyA2a7e3NA1RyZbyCw2Zt9jSpBjnp1xzzRc'
      // axios
      //   .get(apiSnippetUrl)
      //   .then(res => {
      //     channelSnippet.push(res.data.items[0])
      //   })
      //   .catch(error => console.log(error))
      context.commit('setChannelSnippet', response)
      firebaseDatabase.collection('creators')
        .doc(firebaseAuth.currentUser.uid)
        .update({
          channel: true,
        })
    },
    async getChannelBranding(context, response) {
      // const channelBranding = []
      // const apiBrandingUrl = `https://youtube.googleapis.com/youtube/v3/channels?part=brandingSettings&id=${this.state.youtube.channelID}&key=AIzaSyA2a7e3NA1RyZbyCw2Zt9jSpBjnp1xzzRc`
      // axios
      //   .get(apiBrandingUrl)
      //   .then(res => {
      //     channelBranding.push(res.data.items[0].brandingSettings.image.bannerExternalUrl + '=w1060-fcrop64=1,00005a57ffffa5a8-k-c0xffffffff-no-nd-rj')
      //   })
      //   .catch(error => console.log(error))
      context.commit('setChannelBranding', response)
    },
    async getChannelStatistics(context, response) {
      // const channelStatistics = []
      // const apiStatisticsUrl = `https://youtube.googleapis.com/youtube/v3/channels?part=statistics&id=${this.state.youtube.channelID}&key=AIzaSyA2a7e3NA1RyZbyCw2Zt9jSpBjnp1xzzRc`
      // axios
      //   .get(apiStatisticsUrl)
      //   .then(res => {
      //     channelStatistics.push(res.data.items[0])
      //   })
      //   .catch(error => console.log(error))
      context.commit('setChannelStatistics', response)
    },
  },
  getters: {
    state: state => state,
  },
}
